import { createSlotRecipe } from './runtime.js';

const popoverConfig = {"name":"popover","slots":["root","trigger","content","arrow","close"],"defaultVariants":{"type":"standard"},"variantMap":{"type":["custom","standard"]}}

export const popover = /* @__PURE__ */ createSlotRecipe(popoverConfig)